let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("47OwM")).then(() => parcelRequire('5RjyS'));